import FilePresentOutlinedIcon from '@mui/icons-material/FilePresentOutlined';
import { CardVariant, WsCard } from 'wisestep-base';

interface INoTemplateCardProps {
  onClick: () => void;
}

const NoTemplateCard = ({ onClick }: INoTemplateCardProps) => (
  <WsCard
    cardType={CardVariant.WITH_OUT_BG}
    title="No Templates Found"
    description=""
    middleComponent={<FilePresentOutlinedIcon />}
    isButton={true}
    onClick={onClick}
    buttonText="Create New Template"
  />
);

export default NoTemplateCard;
